
import Backbone from 'backbone'
import template from './slide-controls.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import $ from 'jquery'
import icon from 'scoreboard/components/icon'
import conductor from 'scoreboard/components/conductor'
import KeyCodes from 'scoreboard/components/key-codes'
import dropdown from 'scoreboard/components/dropdown'
import permissions from 'scoreboard/components/permissions'
import Slide from './slide'
import Tooltip from 'scoreboard/components/tooltip'
import BriefingOptionsMenu from './briefing-options-menu'
import selects from 'scoreboard/components/selects'
import ForwardBackwardSizer from 'scoreboard/components/forward-backward-sizer'
import layoutManager from 'scoreboard/components/layout-manager'
import constants from 'scoreboard/components/constants'
import PeriodDisplay from 'scoreboard/components/period-display'
import RelativePeriodDisplay from 'scoreboard/components/relative-period-display'
import briefingsLayoutManager from './briefings-layout-manager'
import appDisplay from 'scoreboard/components/app-display'
import isRtl from 'scoreboard/components/is-rtl'

var SlideControls = Backbone.View.extend({

	// this.model is a Briefing
	// this.options.slideId is (optionally) the name of the current slide

	className: 'slide-controls is-editable',

	// if we are currently in fullscreen mode
	fullscreen: false,
	// if we are currently in a paused briefing.  start null so that when
	// initially rendering the controls, the heading renders correctly
	paused: null,
	// if we are in the process of resuming a briefing
	resuming: false,

	events: {
		// navigation between slides
		'change select.slides': '_changeSlide',
		'click .fullscreen': 'toggleFullscreen',
		'click .done': 'done',
		'click button.edit': 'edit',
		'click .resume-briefing': 'resume',
		'click .send-to': 'sendTo'
	},

	initialize: function(options) {
		this.options = options || {}
		this.setModel(this.model)

		this.listenTo(Backbone, 'add:domain-object', this._saveSlide.bind(this))
		this.listenTo(Backbone, 'edit:domain-object', this._onEdit.bind(this))
		this.listenTo(Backbone, 'move:domain-object', this._onMove.bind(this))
		this.listenTo(Backbone, 'copy:domain-object', this._onCopy.bind(this))
		this.listenTo(Backbone, 'delete:domain-object', this._onDelete.bind(this))
		this.listenTo(Backbone, 'route:success', this._route.bind(this))
		// #20128 dataset drilldown routes from dashboards don't trigger the 'route'
		// event, because they have a lot of data that isn't communicated in a
		// url (like filters). Instead, datasets-router will trigger this event
		// when the drilldown is done
		this.listenTo(Backbone, 'datasets:drilldown:done', this._route.bind(this))
		this.listenTo(layoutManager, 'resize', () => {
			this.resize(true)
			this.hideChildren(false)
		})
		_.bindAll(this, 'keyup')
		this._bindKeys()
	},

	// Toggle the visibility of the children.
	// Used in order to hide/show buttons during/after transitioning to MODE_PRESENTATION
	hideChildren: function(hide) {
		this.$el.toggleClass('hide-children', hide)
	},

	setModel: function(model) {
		this.stopListening(this.model)
		this.model = model
		// note: don't listen to the change:slides event because we handle
		// updating the slide dropdown more surgically in the _onEdit,
		// _onMove, _onCopy and _onDelete methods
		this.listenTo(this.model, 'change:label', function() {
			this.$('h1').text(this.model.get('label'))
		}.bind(this))
		this.listenTo(this.model, 'reoder:slides', this._renderSlides.bind(this))
	},

	render: function() {
		this.$el.empty().append(template(this.model.attributes))

		this.slideSelect = this.$('select.slides')

		// select the correct slide and adjust backward/forward buttons as appropriate
		var slideId = _.result(this.options, 'slideId') || _.result(this.model.get('slides'), '[0].id')
		this.slideSelect.val(slideId)
		this._toggleBackwardForward()

		// handle an invalid slide or no slides by hiding the previous/next
		// slide buttons and the controls in the middle
		var slide = this.model.slides().get(slideId)
		if (!slide || _.isEmpty(this.model.slides())) {
			this.$el.addClass('no-slides')
		}

		this._renderSlides(slideId)
		this.secure()

		this.forwardBackwardSizer = new ForwardBackwardSizer({
			select: this.$('.select.slides'),
			controls: this.$('.slide-control'),
			backward: this.$('.backward'),
			forward: this.$('.forward')
		}).render()
		this.forwardBackwardSizer.on('backward', () => this.backward())
		this.forwardBackwardSizer.on('forward', () => this.forward())
		this._resetButtonsAndLabel()
		this.resize()
		return this
	},

	secure: function() {
		if (!permissions.briefings(this.model.get('organizationId'))) {
			this.$el.removeClass('is-editable')
		}
	},

	// returns the ID of the slide currently selected in the slide dropdown in
	// the slideControls
	getSlideId: function() {
		return this.slideSelect.val()
	},

	setSlideId: function(slideId) {
		if (slideId) {
			this.slideSelect.val(slideId)
			// Update the select without a change event so we aren't stuck in an infinite loop
			selects(this.slideSelect)
		}
	},

	_renderSlides: function(slideId) {
		var slides = this.model.get('slides')

		if (_.isEmpty(slides)) {
			this.$el.addClass('no-slides')
		} else {
			this.$el.removeClass('no-slides')
			slideId = slideId || this.slideSelect.val()
			var options = []
			_.each(slides, function (slide, index) {
				options.push({
					id: slide.id,
					label: slide.label,
					selected: slide.id == slideId,
					preLabel: i18n.get('common.index', index+1, slides.length)
				})
			})

			dropdown.idLabels(this.slideSelect.empty(), options, slideId)

			// stay on the slide we were on before
			this.setSlideId(slideId)
		}
	},

	// disables the backward or forward button if appropriate
	_toggleBackwardForward: function() {
		var select = this.slideSelect[0]
		this.$('.backward').toggleClass('is-disabled', select.selectedIndex == 0)
		this.$('.forward').toggleClass('is-disabled', select.selectedIndex == select.length - 1)
	},

	setMode: function(mode) {
		if (briefingsLayoutManager.isPaused()) {
			return
		}
		this._toggleBackwardForward()
		this.$el.removeClass(constants.BRIEFING_MODE_IS_EDITING_SLIDE)
			.removeClass(constants.BRIEFING_MODE_IS_EDITING_BRIEFING)
		// disable the controls when editing a briefing (but not when editing a slide)
		this.$('input, select, button').prop('disabled', mode === constants.BRIEFING_MODE_IS_EDITING_BRIEFING)
		// #12551 re-draw select without triggering change event in case it was disabled or enabled
		selects(this.$('select'))
		// if editing a slide or briefing
		if (mode) {
			this.$('.button.done').prop('disabled', false)
			if (!this.model.isNew()) {
				this.$('.button.done').removeClass('is-not-displayed')
			}
			this.$el.addClass(mode)
		}
		if (_.isEmpty(this.model.get('slides'))) {
			this.$('.fullscreen').attr('disabled', true)
		}
		if (mode != constants.BRIEFING_MODE_IS_EDITING_BRIEFING) {
			this._toggleBackwardForward()
		}
		if (mode == constants.BRIEFING_MODE_IS_EDITING_SLIDE) {
			this.$('.button.fullscreen').prop('disabled', true)
		}

		return this
	},

	getMode: function() {
		var classes = this.$el.attr('class')
		if (!classes) {
			return null
		}

		if (classes.indexOf(constants.BRIEFING_MODE_IS_EDITING_SLIDE) != -1) {
			return constants.BRIEFING_MODE_IS_EDITING_SLIDE
		} else if (classes.indexOf(constants.BRIEFING_MODE_IS_EDITING_BRIEFING) != -1) {
			return constants.BRIEFING_MODE_IS_EDITING_BRIEFING
		} else {
			return constants.BRIEFING_MODE_IS_VIEWING_SLIDE
		}
	},

	_bindKeys: function () {
		$(document).on('keyup', this.keyup)
	},

	_unbindKeys: function () {
		$(document).off('keyup', this.keyup)
	},

	// advance through slides based on using the keyboard
	// https://github.com/SpiderStrategies/Scoreboard/issues/6214
	keyup: function(e) {
		// only respond to keys in non-paused, fullscreen briefings
		if (!briefingsLayoutManager.isBriefingPresentationMode()
			|| briefingsLayoutManager.isPaused()) {
			return
		}

		var backwardKeys = !isRtl() ? [KeyCodes.LEFT, KeyCodes.UP, KeyCodes.PAGE_UP] :
			[KeyCodes.RIGHT, KeyCodes.UP, KeyCodes.UP]
		var forwardKeys = !isRtl() ? [KeyCodes.RIGHT, KeyCodes.DOWN, KeyCodes.PAGE_DOWN] :
			[KeyCodes.LEFT, KeyCodes.DOWN, KeyCodes.PAGE_DOWN]

		if (_.includes(backwardKeys, e.keyCode)) {
			this.backward()
		}
		if (_.includes(forwardKeys, e.keyCode)) {
			this.forward()
		}
		/* this is in SB2 but I couldn't get it to work in SB3.  The browser
		and Backbone both really want control of the Backspace key it seems
		if (e.keyCode == KeyCodes.BACKSPACE) {
			e.preventDefault()
			e.stopPropagation()
			return false
		}
		*/
		if (e.keyCode == KeyCodes.ESC) {
			this.toggleFullscreen()
		}
	},

	backward: function() {
		this.nav(-1)
	},

	forward: function() {
		this.nav(1)
	},

	nav: function(direction) {
		// make sure the index is valid, in case we started out with an
		// invalid slide ID
		var oldIndex = this.slideSelect[0].selectedIndex
		var index = oldIndex
		// if nothing was selected explicitly, the first slide was displayed
		// in the dropdown so normalize the index to 0
		if (index == -1) {
			index = 0
		}
		// now advance the slide in the desired direction
		index += direction
		// now make sure we're not outside the valid range of slides
		index = Math.max(index, 0)
		index = Math.min(index, this.slideSelect[0].options.length-1)

		var slideId = this.slideSelect.find('option').eq(index).val()
		this.slideSelect.val(slideId)
		this._changeSlide()
		this._renderSlides()
		// must be AFTER this.view() or back/forward buttons aren't disabled
		// correctly
		this._toggleBackwardForward()
	},

	_changeSlide: function() {
		this.setCurrentView(null)
		this._toggleBackwardForward()
		this.view()
		this.resize()
	},

	toggleFullscreen: function() {
		// Hide slide controls until we're finished with the transition
		// to avoid control overlapping for a split
		// second before things are resized properly
		this.hideChildren(true)

		this.fullscreen = !this.fullscreen
		var buttonKey = this.fullscreen ? 'common.stop' : 'common.start'
		this.$('.fullscreen .action-toggle').text(i18n.get(buttonKey))

		if (briefingsLayoutManager.isPaused()) {
			this._resetButtonsAndLabel(false)
		}

		this.$('.fullscreen').addClass('soft-disable')
		briefingsLayoutManager.toggleStart(this.fullscreen).then(() => {
			this.$('.fullscreen').removeClass('soft-disable')
			this.hideChildren(false)
		})
	},

	slideLabel() {
		var slide = this.model.slides().get(this.getSlideId())
		return slide && slide.get('label')
	},

	getSlideInfo() {
		return {
			label: this.slideLabel(),
			slideNumberText: this.$('.slides .pre-label').text()
		}
	},

	togglePaused: function(paused) {
		if (paused === briefingsLayoutManager.isPaused()) {
			return
		}

		this._resetButtonsAndLabel(paused)
		this.isTogglingPauseState = true
		briefingsLayoutManager.togglePaused(paused).then(() => {
			this.isTogglingPauseState = false
		})
	},

	_resetButtonsAndLabel: function(paused) {
		var html
		if (paused) {
			html = icon('briefings')
				+ '<h1 class="briefing-label">' +
				_.escape(this.model.get('label')) + '&mdash;' + _.escape(this.slideLabel())
				+ '</h1>'
			html = '<a class="resume-briefing">'
				+ i18n.get('briefingBooks.resumeAt', html)
				+ '</a>'
		} else {
			html = icon('briefings')
				+ '<h1 class="briefing-label">' +
				_.escape(this.model.get('label'))
				+ '</h1>'
		}

		this.$('.slides, .backward button, .forward button').prop('disabled', paused)
		this.$('.briefing-label-wrapper').html(html)

		// If this is a newly created briefing, show "Create Briefing as the label"
		// in place of a name which has yet to be saved.
		if (this.model.isNew()) {
			this.$('.briefing-label')
				.text(i18n.get('common.create2', 'briefingBooks.briefingBook'))
			this.$('button.done').addClass('is-not-displayed')
		}
	},

	// In fullscreen mode, the design has the slide-controls containing the period-display instead
	// of in the display-pane. To handle this, we will append a new period-display that syncs to the
	// behavior of the display-header's period-display
	updatePeriodDisplay(periodDisplay, periodId, relative, periodDelta) {
		if (periodDisplay) {
			if (relative) {
				this.periodDisplay = new RelativePeriodDisplay({
					periodId: periodId,
					periodDelta: periodDelta
				})
			} else {
				this.periodDisplay = new PeriodDisplay({ briefingSpecificPeriodId: periodId })
			}
			this.$('.period-display').empty().append(this.periodDisplay.el)
			this.periodDisplay.render()
		} else {
			this.$('.period-display').empty()
		}
	},

	// reset the controls so that the first slide is displayed
	reset: function() {
		this.slideSelect.prop('selectedIndex', 0).change()
		this._toggleBackwardForward()
	},

	// view the currently selected slide (not editing anything or full screen)
	view: function() {
		this.trigger('view', this.getSlideId())
	},

	edit: function() {
		conductor.navigate('briefings/' + this.model.id + '/edit', { trigger: true })
	},

	// handles when the user clicks done after editing a briefing or slide
	done: function() {
		// Pass no value into setMode() to get buttons back to normal state
		this.setMode()
		if(this.getSlideId()) {
			this.trigger('view', this.getSlideId())
		} else {
			conductor.navigate('briefings/' + this.model.id, { trigger: true })
		}
		// #41921 change nav pane 'Edit' button to 'Done'
		_.invoke(appDisplay.navView(), 'toggleEditViewState', false)
	},

	// resume a briefing at the previously viewed slide
	resume: function() {
		this.trigger('resume', this.getSlideId())
	},

	// Resize .slide-controls and the controls contained inside it based on the
	// available width and state of the briefing. Also, appends size related
	// classes to .slide-controls for styling purposes.
	resize: function(disableTransitions) {
		// When toggling between pause/resume, the slide controls width changes, but gradually.
		// Therefore, we need to get the calculation using two elements whose width doesn't transition
		// when toggling between the two modes. The difference between width of the body and orgPaneToggler
		// will equate to the ending width of the slide-controls
		this.$el.removeClass('slide-controls-small')
		var body = $('body')
		var bodyWidth = body.width()
		var orgToggler = $('.project-organization-menu')
		var orgPaneTogglerWidth = (orgToggler.css('display') == 'none' || orgToggler.css('left') < '0px') ? 0 : orgToggler.width()

		// Get the current briefing state to help in figuring what to adjust.
		var briefingState = this.getMode() || {}
		// Append a few more states based on presentation state
		briefingState.IS_PRESENTATION = briefingsLayoutManager.isBriefingPresentationMode()
		// Figure out .slide-controls total width and classify it
		var totalWidth = briefingState.IS_PRESENTATION ? bodyWidth : bodyWidth - orgPaneTogglerWidth

		// Toggle size related classes based on the width of .slide-controls
		// (used for styling in slide-controls.scss)
		var buttonControls = this.$('.briefing-button-controls')
		// If .briefing-label-wrapper and .briefing-button-controls are visible. Make
		// sure they fit by adjusting .briefing-label-wrapper
		this.$('.briefing-label-wrapper').css('max-width', totalWidth - buttonControls.width() - 20) // 20 = margin
		var briefingButtons = briefingState.IS_EDITING_BRIEFING ? this.$('.briefing-edit-buttons') : buttonControls
		// If only the .slide-options and .briefing-button-controls are visible.
		// Make sure they fit by adjusting .slide-options.
		let slideOptionsMaxWidth = totalWidth - briefingButtons.width() - 30
		let slideOptions = this.$('.slide-options')
		slideOptions.css('max-width', slideOptionsMaxWidth)
		let controlsTotalWidth = buttonControls.width() + slideOptions.width()
		let hamburgerWidth = this.$('.hamburger')[0].clientWidth + constants.STANDARD_MARGIN
		let toggleSmallControls =
			totalWidth < controlsTotalWidth + hamburgerWidth ||
			totalWidth < 500
		this.$el.toggleClass('slide-controls-small', toggleSmallControls)
		// prevent initial flicker in slide pane due to responsive design
		this.$el.removeClass('is-not-visible')
	},

	// handles when a slide is added or edited
	_saveSlide: function(model) {
		if (model instanceof Slide && this.model.id == model.get('briefingId')) {
			// all this so we can make sure we get (1 of 17) at the end of the
			// slide name.  re-rendering the slides dropdown shouldn't take long
			var slide = this.model.slides().add(model, { merge: true })

			// If there's only one slide, pass it's id into _renderSlides so it can
			// be selected by default (#33057)
			if (this.model.slides().length == 1) {
				this._renderSlides(slide.id)
			} else {
				this._renderSlides()
			}
		}
	},

	_onEdit: function(model) {
		if (this.getMode() === constants.BRIEFING_MODE_IS_EDITING_BRIEFING) {
			this.$('h1').text(model.get('label'))
		}
		if (this.getMode() === constants.BRIEFING_MODE_IS_EDITING_SLIDE) {
			this._saveSlide(model)
		}
	},

	_onMove: function(options, ids) {
		if (this.getMode() === constants.BRIEFING_MODE_IS_EDITING_SLIDE) {
			this.model.slides().remove(options.id)
			if (this.model.slides().isEmpty()) {
				conductor.navigate(`briefings/${this.model.id}/edit`, { trigger: true })
				this.$el.addClass('no-slides')
				this.setMode(constants.BRIEFING_MODE_IS_EDITING_BRIEFING)
			} else {
				// normally we stay on the same slide index
				let index = this.slideSelect[0].selectedIndex
				// however, if the slide removed was the last slide, we need to
				// decrement the index
				if (index >= this.model.slides().length) {
					index--
				}

				let slideId = this.model.slides().at(index).id
				this.slideSelect.val(slideId)
				this._changeSlide()
				this._renderSlides()
				// must be AFTER this.view() or back/forward buttons aren't disabled
				// correctly
				this._toggleBackwardForward()
			}
		}
	},

	_onCopy: function(options, ids) {
		if (this.getMode() === constants.BRIEFING_MODE_IS_EDITING_SLIDE) {
			// if we copied to this BB
			if (options.parentId == this.model.id) {
				// add the slide to the end of the list of slides, and render
				// the list again
				var newSlide = this.model.slides().get(options.id).clone()
				newSlide.set('id', ids[options.id])
				this.model.slides().add(newSlide)
				this._renderSlides()
				this._toggleBackwardForward()
			}
		}
	},

	_onDelete: function(model) {
		if (model instanceof Slide) {
			// fix slide dropdown
			var index = this.slideSelect.prop('selectedIndex')

			if (model.id == this.slideSelect.val()) {
				// handle when there are no more slides
				if (this.slideSelect.find('option').length == 1) {
					this.$el.addClass('no-slides')
					conductor.navigate('briefings/' + this.model.id, { trigger: true })
					return
				}

				// if deleting the first slide
				if (index == 0) {
					// the next slide will need to be chosen
					index = 1
				// if deleting the last slide need to go back one
				} else if (index == this.slideSelect[0].options.length-1) {
					index--
				// if deleting something in the middle go forward one slide
				} else {
					index++
				}
			}
			this.slideSelect.prop('selectedIndex', index)
			this.model.slides().remove(model.id)
			this._renderSlides()
			this._toggleBackwardForward()
			// show the current slide in the display pane
			if (this.getMode() === constants.BRIEFING_MODE_IS_EDITING_SLIDE) {
				this.view()
			}
		}
	},

	/**
	 * _route is called when the app route changes. Depending on the briefing mode
	 * we're in and whether the route we just hit is a briefing route or not, we
	 * need to either enter pause mode, exit it, or exit the briefing layout altogether.
	 **/
	_route: function() {
		if (this.isTogglingPauseState) {
			return
		}

		let isPaused = briefingsLayoutManager.isPaused()
		let nonBriefingRoute = conductor.section() !== 'briefings'

		// Enter the paused state if:
		// - We're in presentation mode
		// - We just hit a non briefings route
		// - We're not already paused
		if (briefingsLayoutManager.isBriefingPresentationMode()
			&& nonBriefingRoute && !isPaused) {
			this.togglePaused(true)
		// Turn off the briefing look and remove the slide-controls if:
		// - We are not in briefings presentation mode
		// - We just hit a non briefings route
		} else if (!briefingsLayoutManager.isBriefingPresentationMode()
			&& nonBriefingRoute) {
			briefingsLayoutManager.toggleBriefingLayout(false)
			this.remove()
		}
	},

	sendTo: function(e) {
		var target = $(e.currentTarget)

		let uiState = (opt) => {
			if (this.currentView && this.currentView.getState) {
				// The BriefingOptionsMenu is only created when the briefing is
				// first opened, so we need to make sure we're getting the state
				// from the current slide's View
				let state = this.currentView.getState(opt)
				state.currentSlideId = parseInt(this.getSlideId())

				return state
			}

			return null
		}

		this.sendToTooltip = new Tooltip({
			attachTo: target,
			content: new BriefingOptionsMenu({
				model: this.model,
				uiState
			}),
			placement: 'below',
			arrow: 'right',
			extraClass: 'has-bootslide-menu'
		}).render()
	},

	setCurrentView: function (view) {
		this.currentView = view
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.sendToTooltip, this.forwardBackwardSizer, this.periodDisplay], 'remove')
		this._unbindKeys()
	}

})

export default SlideControls

SlideControls.__filename__ = 'briefings/slide-controls.js'
